
<header [ngClass]="{'sticky':headerStickyFlag}"  >
    <h1>
        <a routerLink="/" (click)="clickRemove()"></a>
    </h1>
    <div id="lnb"> 
        <nav id="nav" >
            <ul id = "test" [ngClass]="{'hover': navHoverFlag , 'visible':visibleFlag}"  (mouseenter)="mouseHover()" (mouseleave)="mouseLeave()">
                <li><a routerLink="/company/vision" (click)="clickRemove()">회사소개</a>
                    <ul>
                        <li><a routerLink="/company/vision" (click)="clickRemove()">비전/경영이념</a></li>
                        <li><a routerLink="/company/technology" (click)="clickRemove()">핵심기술</a></li>
                        <li><a routerLink="/company/location" (click)="clickRemove()">오시는 길</a></li>
                    </ul></li>
                <li><a routerLink="/product/billiai" (click)="clickRemove()"> 제품소개</a>
                    <ul>
                        <li><a routerLink="/product/billiai" (click)="clickRemove()">BilliAI</a></li>
                        <li><a routerLink="/product/carrotly" (click)="clickRemove()">Carrotly</a></li>
                    </ul></li>
                <li><a routerLink="/recruit/talent" (click)="clickRemove()">인재채용</a>
                    <ul>
                        <li><a routerLink="/recruit/talent" (click)="clickRemove()">인재상</a></li>
                        <li><a routerLink="/recruit/welfare" (click)="clickRemove()">복리후생</a></li>
                        <li><a routerLink="/recruit/recruitList" (click)="clickRemove()">채용알림</a></li>
                    </ul></li>
                <!-- <li><a routerLink="/news/notice" (click)="clickRemove()">소식</a>
                    <ul>
                        <li><a routerLink="/news/notice" (click)="clickRemove()">알림</a></li>
                    </ul></li> -->
            </ul>	
        </nav>
        <div id="box" [ngClass]="{'hover': navHoverFlag}" ></div>
            <i class="xi-bars" id="xi-bars" (click)="clickBar()"></i>
    </div>
    
    <ul>
        <li><a routerLink="">KOR</a></li>
    </ul>
</header>